module.exports = __webpack_public_path__ + "img/Watermark_PiggyBank@2x.18a97c63.png";